import { render, staticRenderFns } from "./ScreenInfo.vue?vue&type=template&id=3991649f&scoped=true&"
import script from "./ScreenInfo.vue?vue&type=script&lang=js&"
export * from "./ScreenInfo.vue?vue&type=script&lang=js&"
import style0 from "./ScreenInfo.vue?vue&type=style&index=0&id=3991649f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3991649f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
